var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Vueditor',{ref:"editor",on:{"change":function () { return _vm.testEditor(_vm.$e); }}}),_vm._v(" "),_c('button',{on:{"click":_vm.testEditor}},[_vm._v("click See Console")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }